import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import CodeInputModal from "./CodeInputModal";
import ChangePasswordModal from "./ChangePasswordModal";
import { requestReset } from "../../../features/auth/authSlice";

export default function ResetPasswortModal({ isOpen, onClose }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1); // 1 = Email, 2 = Code, 3 = Passwort ändern
  const [code, setCode] = useState("");
  const dispatch = useDispatch();

  const handleReset = async () => {
    if (!email || !email.includes("@") || !email.includes(".")) {
      toast.error("Bitte geben Sie eine gültige Email-Adresse ein.");
      return;
    }

    setLoading(true);

    dispatch(requestReset({ email }))
      .unwrap()
      .then(() => {
        toast.success("Code wurde an Ihre Email gesendet.");
        setStep(2);
      })
      .catch((err) => {
        toast.error(err.message || "Fehler beim Senden der E-Mail");
      })
      .finally(() => setLoading(false));
  };

  const handleCodeSubmit = () => {
    if (!/^\d{6}$/.test(code)) {
      toast.error("Bitte Code eingeben");
      return;
    }

    setStep(3);
  };

  return (
    <>
      {step === 3 ? (
        <ChangePasswordModal email={email} code={code} onClose={onClose} />
      ) : (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
            <div className="flex flex-col items-center justify-center gap-2">
              {step === 1 ? (
                <h2 className="kn-h3 mb-4">E-Mail eingeben</h2>
              ) : (
                <>
                  <h2 className="kn-h3">E-Mail verifizieren</h2>
                  <p className="kn-body mb-6">
                    Wir haben Ihnen einen Bestätigungscode geschickt!
                  </p>
                </>
              )}
            </div>

            {step === 1 ? (
              <div className="flex flex-col gap-4">
                <input
                  type="email"
                  placeholder="Email"
                  className="inputStyle"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            ) : (
              <CodeInputModal onCodeChange={setCode} />
            )}

            <div className="flex flex-col w-full items-center justify-center mt-6 gap-4">
              <div className="flex justify-center gap-3 w-full">
                <button onClick={onClose} className="kn-btn-ghost">
                  Abbrechen
                </button>
                <button
                  onClick={step === 1 ? handleReset : handleCodeSubmit}
                  disabled={loading}
                  className="kn-btn-primary"
                >
                  {loading
                    ? "Wird gesendet..."
                    : step === 1
                      ? "Code anfordern"
                      : "Code bestätigen"}
                </button>
              </div>

              {step === 2 && (
                <div className="flex gap-1 text-center">
                  <p>Keinen Code erhalten?</p>
                  <button
                    type="button"
                    onClick={handleReset}
                    disabled={loading}
                    className="font-semibold text-knapp-accent hover:underline cursor-pointer disabled:opacity-50"
                  >
                    Erneut senden
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
